import { ECareDeviceEvents, ECareDeviceEventsDTO } from './eCareDeviceEvents.types';

export const parseSingleECareAlarmForFE = (eCareDeviceEventDTO: ECareDeviceEventsDTO): ECareDeviceEvents => ({
  value: eCareDeviceEventDTO.value,
  label: eCareDeviceEventDTO.label,
});

export const parseECareAlarmsListForFE = (eCareDeviceEventDTO: ECareDeviceEventsDTO[]): ECareDeviceEvents[] =>
  eCareDeviceEventDTO.map(parseSingleECareAlarmForFE);
